import type { CursorPage } from '@dru/types';
import { api } from './api';

/**
 * One page of a cursor-paginated list, shaped for `EntityCombobox`.
 *
 * A one-line helper because every searchable picker needs the same three
 * things — append the cursor, call the endpoint, hand back `{ items,
 * nextCursor }` — and writing that inline at twenty call sites is twenty
 * chances to forget the cursor and quietly return page one forever.
 *
 * `path` already carries its own query string, including the search term, so
 * the cursor is appended with `&`.
 */
export async function page<T>(path: string, cursor: string | null) {
  const res = await api.get<CursorPage<T>>(cursor ? `${path}&cursor=${cursor}` : path);
  return { items: res.items, nextCursor: res.nextCursor };
}

/**
 * The same, across every plant the login can reach — ignoring the plant
 * chosen in the header. For pickers that send someone to another plant
 * (a transfer), where the viewed plant must not hide the destination.
 */
export async function pageAllPlants<T>(path: string, cursor: string | null) {
  const res = await api.getAllPlants<CursorPage<T>>(cursor ? `${path}&cursor=${cursor}` : path);
  return { items: res.items, nextCursor: res.nextCursor };
}
